import type { ReactNode } from 'react';
import './ChartCard.css';

export function ChartCard({ title, actions, children }: { title: string; actions?: ReactNode; children: ReactNode }) {
  return (
    <section className="chart-card">
      <div className="chart-card-header">
        <h2>{title}</h2>
        {actions}
      </div>
      {children}
    </section>
  );
}
